import usePageMeta from '@/hooks/usePageMeta';

const SECTIONS = [
  {
    title: '1. Kontrolor podataka',
    body: `Kontrolor obrade ličnih podataka je Društvo sa ograničenom odgovornošću "GARMOND" d.o.o. Sarajevo, sa sjedištem u ulici Željeznička broj 112, Sarajevo, JIB 4200650870003, MBS 65-01-0025-13 ("Garmond Graphic", "mi").`,
  },
  {
    title: '2. Koje podatke prikupljamo',
    body: `Naša internet stranica ne sadrži formulare koji automatski prikupljaju vaše lične podatke. Do ličnih podataka dolazimo isključivo kada nam ih vi dobrovoljno dostavite — putem telefonskog poziva, emaila, WhatsApp poruke ili društvenih mreža — radi zahtjeva za ponudom, upita ili dogovaranja saradnje. To mogu biti ime i prezime, naziv kompanije, kontakt telefon, email adresa i sadržaj vašeg upita.`,
  },
  {
    title: '3. Svrha obrade',
    body: `Podatke koristimo isključivo radi odgovora na vaš upit, pripreme ponude, komunikacije u vezi sa narudžbom ili pružene usluge, te ispunjenja zakonskih obaveza (npr. knjigovodstvenih i poreskih propisa u Bosni i Hercegovini). Ne koristimo vaše podatke u marketinške svrhe bez vaše prethodne saglasnosti.`,
  },
  {
    title: '4. Dijeljenje podataka s trećim stranama',
    body: `Vaše podatke ne prodajemo niti ustupamo trećim licima, osim kada je to neophodno za izvršenje usluge (npr. dostavljačke službe) ili kada je to zakonom propisano. Komunikacija putem WhatsAppa i drugih platformi podliježe i pravilima privatnosti tih platformi (npr. Meta/WhatsApp, Google, Facebook).`,
  },
  {
    title: '5. Kolačići (cookies)',
    body: `Stranica trenutno ne koristi kolačiće za analitiku ili oglašavanje treće strane. Ukoliko to u budućnosti promijenimo, ova politika će biti ažurirana u skladu s tim.`,
  },
  {
    title: '6. Čuvanje podataka',
    body: `Lične podatke čuvamo onoliko dugo koliko je potrebno za ostvarenje svrhe zbog koje su prikupljeni, odnosno u skladu sa zakonskim rokovima čuvanja poslovne dokumentacije.`,
  },
  {
    title: '7. Vaša prava',
    body: `U skladu sa Zakonom o zaštiti ličnih podataka Bosne i Hercegovine, imate pravo zatražiti uvid, ispravku ili brisanje vaših ličnih podataka, kao i uložiti prigovor na način njihove obrade. Zahtjev možete poslati na email garmond@garmond.ba ili putem kontakt podataka navedenih na ovoj stranici.`,
  },
  {
    title: '8. Izmjene politike privatnosti',
    body: `Zadržavamo pravo izmjene ove politike privatnosti. Aktuelna verzija je uvijek dostupna na ovoj stranici.`,
  },
];

export default function PolitikaPrivatnosti() {
  usePageMeta({ title: 'Politika privatnosti | Garmond Graphic', path: '/politika-privatnosti' });

  return (
    <section className="bg-white py-32 border-t border-slate-200" data-testid="privacy-policy-page">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <span className="eyebrow text-[#E60000] mb-4 block">Pravne informacije</span>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#0A0A0A] tracking-tight uppercase leading-[0.95] mb-10">
          Politika privatnosti
        </h1>

        <div className="space-y-10">
          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h2 className="text-lg font-bold text-[#0A0A0A] mb-2">{section.title}</h2>
              <p className="text-slate-600 text-base leading-relaxed font-light">{section.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
